<template>
  <div>
    <img style="width:100%" src="../assets/school.jpg" alt="">
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>